export default "__VITE_ASSET__$GDEL0$O__"